import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#065A79', 
    },
    secondary: {
      main: '#dc004e', 
    },
    error: {
      main: '#d32f2f', // red color
    },
  },
});

export default theme;